import { FC } from "react"
import { formInterface } from "@/interface/dataInterface"
import ClientFormCommon from "@/components/common/form/ClientForm"

const ClientForm: FC<formInterface> = ({formProp, setFormProp}) => {
    return (
        <ClientFormCommon formProp={formProp} setFormProp={setFormProp} />

    )
}

export default ClientForm